<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md6>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="house_number"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<p :class="{ 'red--text': !valid }">
								{{ $t("Name") }}
							</p>
							<v-btn-toggle
								v-model="item.name"
								:error-messages="errors"
							>
								<v-btn value="home">
									<v-icon left> mdi-home </v-icon>
									<span>{{ $t("label.home") }}</span>
								</v-btn>
								<v-btn value="office">
									<v-icon left> mdi-briefcase </v-icon>
									<span>{{ $t("label.office") }}</span>
								</v-btn>

								<v-btn value="other">
									<v-icon left> mdi-map-marker </v-icon>
									<span>{{ $t("label.other") }}</span>
								</v-btn>
							</v-btn-toggle>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="house_number"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.house_number"
								:label="$t('label.house_number')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="street"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.street"
								:label="$t('label.street')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md12>
						<ValidationProvider
							name="address"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.address"
								:label="$t('Address')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="phone_number"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.phone_number"
								:label="$t('Phone Number')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="contact_person"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.contact_person"
								:label="$t('label.contact_person')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md12>
						<ValidationProvider
							name="description"
							rules=""
							v-slot="{ errors, valid }"
						>
							<v-textarea
								v-model="item.description"
								:label="$t('Description')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-textarea>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md6 class="pl-10">
				<v-layout row wrap>
					<v-flex xs12 md6>
						<ValidationProvider
							name="latitude"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.latitude"
								:label="$t('Latitude')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="longitude"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.longitude"
								:label="$t('Longitude')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<GmapMap
							:center="{ lat: latitude, lng: longitude }"
							:zoom="15"
							map-type-id="terrain"
							style="width: 100%; height: 400px"
							ref="mapRef"
						>
							<GmapMarker
								:position="{ lat: latitude, lng: longitude }"
								:clickable="true"
								:draggable="true"
								@click="
									center = { lat: latitude, lng: longitude }
								"
								@dragend="updatePosition"
							/>
						</GmapMap>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
		latitude() {
			return this.item.latitude ? this.item.latitude : 11.5564;
		},
		longitude() {
			return this.item.longitude ? this.item.longitude : 104.9282;
		},
	},
	methods: {
		updatePosition(e) {
			this.item.latitude = e.latLng.lat();
			this.item.longitude = e.latLng.lng();
			this.$refs.mapRef.$mapPromise.then((map) => {
				map.panTo({ lat: e.latLng.lat(), lng: e.latLng.lng() });
			});
		},
	},
};
</script>